import { getProfileCvStatusSync } from '~/utils/profileCvStatus'

export default ({ app, $auth, req }) => { // Questo plugin perché la redirect automatica dopo il login dovuto a un URL sotto auth non va con il multilingua
  $auth.onRedirect((to) => {
    // SmartCV: dopo registrazione o login la destinazione dipende dal CV del profilo (doc 118 cap. 2 e 3).
    // Senza CV → "Iniziamo dal tuo CV"; CV caricato (in parsing o da confermare, anche da landing o Indeed)
    // → "Il mio CV"; profilo confermato → destinazione di sempre.
    // MOCK SmartCV: lo stato viene da dataMock/profileCvStatus.js finché get-user-data non lo restituisce
    if (to === 'user-settings-applications' && $auth.user) {
      const cvStatus = getProfileCvStatusSync()
      if (cvStatus === 'none') {
        to = 'welcome'
      } else if (cvStatus === 'unconfirmed') {
        to = 'user-settings-my-cv'
      }
    }
    const isMobile = process.server
      ? /mobile/i.test(req.headers['user-agent'])
      : /mobile/i.test(navigator.userAgent)
    if (to === 'user-settings-applications' && isMobile) {
      to = 'user-settings'
    }
    return app.localePath(to)
  })
}
